import { render, staticRenderFns } from "./Slide.vue?vue&type=template&id=4ef88f55&scoped=true"
import script from "./Slide.vue?vue&type=script&lang=ts"
export * from "./Slide.vue?vue&type=script&lang=ts"
import style0 from "./Slide.vue?vue&type=style&index=0&id=4ef88f55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef88f55",
  null
  
)

export default component.exports